import { Button, Typography } from "antd";

const { Title } = Typography;

interface ProfileHeaderProps {
  title: string;
  onEdit?: () => void;
}

export const ProfileHeader: React.FC<ProfileHeaderProps> = ({
  title,
  onEdit,
}) => {
  return (
    <div className="flex justify-between w-full pr-10">
      <Title level={5}>{title}</Title>
      {onEdit && (
        <Button type="primary" onClick={onEdit}>
          Edit
        </Button>
      )}
    </div>
  );
};
